__turbopack_context__.v({
  "className": "inter_845851d8-module__Sg2zxq__className",
  "variable": "inter_845851d8-module__Sg2zxq__variable",
});
